import React from 'react';
import FC from './FC/FC'
import './FeaturedWork.css'


const FeaturedWork = () => {

return (
    <div className="About-Work">
<FC/>
    </div>
)


}




export default FeaturedWork;